<sdc-table
  [data]="data()"
  [columns]="columns()"
  [showPagination]="false"
  [showSelection]="selectable()"
  [enableSort]="sortable()"
  [pinningHeaders]="pinningHeaders()"
  [className]="className()"
  (selectionChange)="selectionChange.emit($event)"
  (sortingChange)="sortingChange.emit($event)"></sdc-table>

@if (showLoader()) {
  <gs-loader mode="contained" label="Loading page" data-cy="gs-table-loading" />
}
